export default function Distributor() {
  return (
    <section id="distributor" className="relative py-32 overflow-hidden bg-[#0a0a0a]">
      {/* 背景装飾 */}
      <div className="absolute inset-0">
        {/* グリッドパターン */}
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
        {/* 斜線装飾 */}
        <div
          className="absolute inset-0 opacity-[0.025]"
          style={{
            backgroundImage:
              'repeating-linear-gradient(45deg, rgba(255,255,255,0.8) 0, rgba(255,255,255,0.8) 1px, transparent 0, transparent 50%)',
            backgroundSize: '30px 30px',
          }}
        />
        {/* グロー効果 */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-amber-500/10 blur-[120px]" />
        <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-amber-600/5 blur-[100px]" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-amber-600/5 blur-[100px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        {/* ヘッダー部分 */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-20">
          <div>
            <p className="text-amber-500/80 text-xs tracking-[0.4em] uppercase font-medium mb-4">
              Dealers &amp; Partners
            </p>
            <h2 className="text-5xl md:text-6xl font-bold text-white leading-tight">
              販売代理店
            </h2>
          </div>
          <p className="text-white/30 text-base max-w-xs leading-relaxed md:text-right">
            全国の販売代理店を通じて、Spring Sun Bowlをお届けします
          </p>
        </div>

        {/* Coming Soon カード */}
        <div className="relative">
          {/* メインカード */}
          <div className="relative border border-white/10 rounded-2xl overflow-hidden">
            {/* カード内部の背景 */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/[0.03] to-transparent" />

            {/* トップバー */}
            <div className="relative flex items-center gap-2 px-6 py-4 border-b border-white/[0.07]">
              <div className="flex gap-1.5">
                <div className="w-3 h-3 rounded-full bg-white/10" />
                <div className="w-3 h-3 rounded-full bg-white/10" />
                <div className="w-3 h-3 rounded-full bg-white/10" />
              </div>
              <div className="flex-1 flex justify-center">
                <div className="w-48 h-5 rounded-full bg-white/[0.05] flex items-center justify-center">
                  <span className="text-white/20 text-xs tracking-widest">distributor.springsun.jp</span>
                </div>
              </div>
            </div>

            {/* コンテンツエリア */}
            <div className="relative px-8 md:px-20 py-20 flex flex-col items-center text-center">
              {/* COMING SOON バッジ */}
              <div className="inline-flex items-center gap-3 mb-12">
                <div className="h-px w-16 bg-gradient-to-r from-transparent to-amber-500/60" />
                <span className="text-amber-500 text-xs tracking-[0.5em] uppercase font-semibold">
                  Coming Soon
                </span>
                <div className="h-px w-16 bg-gradient-to-l from-transparent to-amber-500/60" />
              </div>

              {/* メインビジュアル - ぼかしたカードプレビュー */}
              <div className="relative w-full max-w-3xl mb-12">
                {/* ぼかしオーバーレイ */}
                <div className="absolute inset-0 z-10 backdrop-blur-md bg-black/40 rounded-xl flex items-center justify-center">
                  <div className="text-center">
                    <div className="relative inline-block">
                      {/* アイコン */}
                      <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-2xl border border-amber-500/30 bg-amber-500/5">
                        <i className="ri-store-3-line text-amber-400 text-3xl" />
                      </div>
                      {/* パルスリング */}
                      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="w-28 h-28 rounded-2xl border border-amber-500/20 animate-ping opacity-40" style={{ animationDuration: '2.5s' }} />
                      </div>
                    </div>
                    <p className="text-white/60 text-sm leading-relaxed max-w-xs mx-auto">
                      全国の販売代理店情報を<br />順次公開予定です
                    </p>
                  </div>
                </div>

                {/* ぼかし対象のカードグリッド（背景として表示） */}
                <div className="grid grid-cols-3 gap-4 p-6 rounded-xl opacity-50">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="rounded-xl bg-white/5 border border-white/[0.06] p-4 h-28" />
                  ))}
                </div>
              </div>

              {/* 下部テキスト */}
              <div className="space-y-3">
                <p className="text-white/50 text-sm leading-relaxed">
                  販売代理店のご契約・お問い合わせは
                  <a href="#contact" className="text-amber-400 hover:text-amber-300 transition-colors duration-200 ml-1 cursor-pointer">
                    こちら
                  </a>
                  からご連絡ください
                </p>
              </div>
            </div>

            {/* 下部ステータスバー */}
            <div className="relative flex items-center justify-between gap-4 px-6 py-4 border-t border-white/[0.07] flex-wrap">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
                <span className="text-white/30 text-xs tracking-widest uppercase">Preparing</span>
              </div>
              <div className="flex items-center gap-6">
                {['東京', '大阪', '名古屋', '福岡', '全国'].map((city, i) => (
                  <span
                    key={i}
                    className="text-white/20 text-xs tracking-wider"
                    style={{ opacity: 0.15 + i * 0.05 }}
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* 角の装飾 */}
          <div className="absolute -top-px -left-px w-8 h-8 border-t-2 border-l-2 border-amber-500/40 rounded-tl-2xl pointer-events-none" />
          <div className="absolute -top-px -right-px w-8 h-8 border-t-2 border-r-2 border-amber-500/40 rounded-tr-2xl pointer-events-none" />
          <div className="absolute -bottom-px -left-px w-8 h-8 border-b-2 border-l-2 border-amber-500/40 rounded-bl-2xl pointer-events-none" />
          <div className="absolute -bottom-px -right-px w-8 h-8 border-b-2 border-r-2 border-amber-500/40 rounded-br-2xl pointer-events-none" />
        </div>
      </div>
    </section>
  );
}
